import { CSSProperties } from 'react';
import './QueueFilterBar.css';

/** The prototype's filter select: `Label · value`, chevron on the right. */
export const QUEUE_FILTER_BUTTON_STYLE: CSSProperties = {
  border: '1px solid #dee2e6',
  borderRadius: 8,
  padding: '6px 8px 6px 10px',
  background: '#fff',
};

export const QUEUE_FILTER_TEXT_PROPS = { fz: 12, lh: '16px', fw: 500, c: 'black' } as const;

/** Picks up the Dark Green focus border from QueueFilterBar.css. */
export const QUEUE_FILTER_BUTTON_CLASS = 'queue-filter-button';
